// src/entry.js
//
// Tiny dispatcher that picks the right main.js to load based on the platform
// detected at boot. Loaded once by index.html via `<script type="module">`.
//
// Why a dispatcher instead of just loading main.js directly: each platform
// (mobile / web) ends up importing different shell chrome + different page
// HTML in Phase 5b. The split is a load-time decision so we don't ship
// mobile-only code (Capacitor plugins, touch gesture lib) to web visitors,
// and vice-versa.
//
// Both import branches are static literal strings so Vite can statically
// analyse and bundle both. At runtime only the chosen path executes.

import { isMobile } from './platform/detect.js';

if (isMobile()) {
  await import('./mobile/main.js');
} else {
  await import('./web/main.js');
}
